"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.formatCurrency = exports.currencyLow = void 0;
exports.getCurrencySymbol = getCurrencySymbol;
var _localization = require("@lt/localization");
var _userflow = require("../constants/userflow");
var DEFAULT_CODE = 'RUB';
var formatCurrency = exports.formatCurrency = function formatCurrency(value) {
  var code = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : DEFAULT_CODE;
  var price = Number(value);
  /**
   * Intl не везде доступен (то ли в nodejs у нас какая-то трабла толи в браузерах)
   * Вот задача в которой фиксил: https://leveltravel.atlassian.net/browse/LT-31774
   * Багов сыпалось очень много, так что не помешало бы разобраться
   * Но проверку не убирать для большей поддержки
   *
   * Лучше всего вынести либо @lt/localization, либо на худой случай в монолит
   */
  try {
    var formattedValue = new Intl.NumberFormat('ru-RU').format(price);
    return formattedValue.concat(_userflow.NBSP, _localization.supportedCurrency[code]);
  } catch (err) {
    return "".concat(price).concat(_userflow.NBSP).concat(_localization.supportedCurrency[code]);
  }
};
function getCurrencySymbol() {
  var code = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : DEFAULT_CODE;
  return _localization.supportedCurrency[code];
}
var currencyLow = exports.currencyLow = function currencyLow() {
  var code = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : DEFAULT_CODE;
  return code.toLowerCase();
};